import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FieldGroup } from '../../../libs/formLib';
import ButtonIcon from '../../common/ButtonIcon';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { animateScroll } from 'react-scroll';

import {
  Button,
  Card,
  CardBody,
  Col,
  FormFeedback,
  FormGroup,
  Label,
  Row,
  TabContent,
  TabPane,
  Alert
} from 'reactstrap';
import VendorMultiSelect from '../section/VendorMultiSelect';
import SummaryModal from '../Vendor/Modal';
import CredsModal from '../Vendor/CredsModal';
import BZAPIService from '../../../services/BZAPIService';
import DefaultConfigTab from '../section/DefaultConfigTab';

import ProductPriority from '../section/ProductPriority';
import TabNav from '../section/TabNav';
import TabOne from '../section/TabOne';
import ExecutionStatsTab from '../section/ExecutionStatsTab';
import AWSFilters from '../section/AWSFilters';
import { useScheduling } from '../../../hooks/useScheduling';

// constants
import SETTINGS from '../../../constants/settings';

const ConfigFormAzure = ({
  vendor,
  isReadOnly,
  // settings,
  vendorLabel,
  vendorId,
  bugsDateBack,
  setBugsDateBack,
  vendorPriorityOptions,
  vendorStatusOptions,
  vendorBugTypeOptions,
  vendorBugCategoryOptions,
  // vendorResolutionOptions,
  snIntegrationCheck,
  services,
  vendors,
  // bugs,
  priorityStats,
  // setPriorityStats,
  // bugOptions,
  // selectedBugOption,
  // setSelectedBugOption,
  snCompanySysIdOptions,
  snCompanySysIdErrors,
  subscriptions,
  setSubscriptions,
  subscriptionOptions,
  setSubscriptionOptions,
  vendorBugTypes,
  setVendorBugTypes,
  fields,
  searchFields,
  setSearchFields,
  snCompanySysId,
  setSnCompanySysId,
  keywords,
  setKeywords,
  priorityMaps,
  setPriorityMaps,
  snPriorityOptions,
  vendorBugCategories,
  setVendorBugCategories,
  vendorStatuses,
  setVendorStatuses,
  handleFieldChange,
  setServices,
  setVendors,
  buildVendorStat,
  setPriorityStats,
  setBugs,
  isConfigured,
  // vendorEventLevelOptions,
  // vendorEventLevels,
  // setVendorEventLevels,
  vendorEventScopeOptions,
  setVendorEventScopes,
  vendorEventScopes,
  syncOnly,
  setSyncOnly,
  vendorImpactedRegions,
  setVendorImpactedRegions,
  vendorImpactedRegionOptions,
  loading,
  autoClose,
  setAutoClose,
  isServiceActive,
  setIsServiceActive,
  allRequired,
  setAllRequired,
  isUpdated,
  setIsUpdated
}) => {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  //  const [config, setConfig] = useState(null);
  const [isValidCredentials, setIsValidCredentials] = useState(false);
  const [isTestingValidCredentials, setIsTestingValidCredentials] = useState(false);
  const [isAddingCredentials, setIsAddingCredentials] = useState(false);

  const [isUpdatingCreds, setIsUpdatingCreds] = useState(false);
  // const [isAddingMFA, setIsAddingMFA] = useState(false);

  const [activeTab, setActiveTab] = useState('1');
  const [modalOpen, setModalOpen] = useState(false);
  const [validated, setValidated] = useState(null);
  const [isForceRun, setIsForceRun] = useState(false);

  // Use scheduling hook for state and save function
  const {
    timeUnit,
    setTimeUnit,
    timeValue,
    setTimeValue,
    schedulingMode,
    setSchedulingMode,
    schedules,
    setSchedules,
    nextRun,
    setNextRun,
    saveBugServiceFrequency
  } = useScheduling();

  async function setBugServiceFrequency() {
    await saveBugServiceFrequency(vendorId);
  }

  async function saveServiceAWSSecret() {
    const data = {
      secret: {
        tenantId: fields.tenantId,
        appId: fields.appId,
        clientSecret: fields.clientSecret
      },
      vendorId: 'azure',
      key: 'admin'
    };
    return BZAPIService.createOrUpdateAWSSecret(data);
    // }
  }

  async function testCreds() {
    setIsTestingValidCredentials(true);
    const data = {
      tenantId: fields.tenantId,
      appId: fields.appId,
      clientSecret: fields.clientSecret
    };
    // if (fields.tenantId.length && fields.appId.length && fields.clientSecret.length) {
    try {
      const result = await BZAPIService.vendorTestCreds(vendorId, data);

      if (result && result.completed) {
        // valid creds
        if (result.subscriptions) setSubscriptionOptions([...result.subscriptions]);
        console.log('results', result);
        setIsAddingCredentials(false);
        setIsValidCredentials(true);
        setIsTestingValidCredentials(false);
        setIsUpdatingCreds(true);
        toast.success(`Credentials validated!`);
      } else {
        toast.error('Error validating credentials.');
        setIsAddingCredentials(false);
        setIsValidCredentials(false);
        setIsTestingValidCredentials(false);
      }
    } catch (e) {
      console.log(e);
      toast.error('Credentials failed validation.');
      setIsTestingValidCredentials(false);
      // setIsAddingCredentials(false);
    }
    // }
  }

  async function saveConfig(serviceSecret) {
    // save client config
    const vendorPriorities = priorityMaps.map(mapping => {
      return {
        value: mapping.vendorPriority.value,
        label: mapping.vendorPriority.value,
        snPriority: mapping.snPriority.value
      };
    });

    const data = {
      secretId: serviceSecret.Name,
      bugsDateBack: bugsDateBack,
      snCompanySysId: snCompanySysId.value ? snCompanySysId.value : fields.snCompanySysId,
      snAffectedCIQuery: fields.snAffectedCIQuery,
      subscriptions: subscriptions,
      excludedKws: keywords,
      searchFields: searchFields,
      vendorPriorities,
      vendorStatuses,
      //   vendorBugCategories,
      type: SETTINGS.VENDOR,
      // vendorEventLevels,
      vendorEventScopes,
      vendorImpactedRegions,
      autoClose
    };

    return BZAPIService.saveSetting(vendorId, syncOnly, data, isForceRun, isUpdatingCreds);
  }

  async function handleSave() {
    try {
      setIsSubmitted(true);
      setIsLoading(true);

      // Validate Secrets
      if (!fields.secretId) {
        if (!fields.tenantId || !fields.appId || !fields.clientSecret) {
          console.log('misisng secret');
          setValidated(false);
          setActiveTab('2');
          setIsLoading(false);
          return;
        }
      }
      // Validate filters
      if (!bugsDateBack.length || !snCompanySysId) {
        console.log('failed validation');
        setValidated(false);
        setActiveTab('3');
        setIsLoading(false);
        return;
      }
      if (
        !priorityMaps.length ||
        // !vendorBugCategories.length ||
        !vendorStatuses.length ||
        // !vendorEventLevels.length ||
        !vendorEventScopes.length ||
        !subscriptions.length ||
        !vendorImpactedRegions.length
      ) {
        // console.log(fields);
        setValidated(false);
        setIsLoading(false);
        setActiveTab('4');
        return;
      }

      let serviceSecret;

      if (fields.appId && fields.tenantId && isValidCredentials) {
        // Updated secrets
        serviceSecret = await saveServiceAWSSecret();
      } else {
        // use existing secrets
        serviceSecret = { Name: fields.secretId };
      }
      // console.log('serviceSecret', serviceSecret);
      if (!serviceSecret || !serviceSecret.Name) {
        setIsLoading(false);
        setValidated(false);
        throw Error('Missing Secret');
      }
      // validate priority maps
      let validPriorities = true;
      priorityMaps.map(item => {
        if (!item.vendorPriority || !item.snPriority) validPriorities = false;
        return item;
      });
      if (!validPriorities) {
        console.log('Invalid priorities');
        setValidated(false);
        setIsLoading(false);
        return false;
      }

      await saveConfig(serviceSecret);
      // set updated secretId
      fields.secretId = serviceSecret.Name;
      setBugServiceFrequency();
      setIsLoading(false);
      setIsSubmitted(false);
      setModalOpen(false);
      setIsForceRun(false);
      setIsUpdatingCreds(false);
      setActiveTab('1');
      toast.success(`Settings Saved!`);
    } catch (e) {
      setIsLoading(false);
      setValidated(false);
      toast.error('Failed to save.');
      console.log('e', e);
    }
  }

  function handleSelectChange(e, setHook) {
    const selected = e || [];
    if (Array.isArray(selected)) setHook(selected.map(el => el));
    else setHook(selected);
  }

  function handleValidationError() {
    setModalOpen(!modalOpen);
    animateScroll.scrollTo(70);
  }

  useEffect(() => {
    setIsUpdated(true);
    if (
      bugsDateBack?.length &&
      snCompanySysId?.value &&
      priorityMaps?.length &&
      !priorityMaps.some(mapping => !mapping.snPriority || !mapping.vendorPriority) &&
      vendorImpactedRegions.length &&
      subscriptions.length &&
      vendorEventScopes.length &&
      vendorStatuses.length &&
      (fields.secretId || (fields.tenantId && fields.appId && fields.clientSecret))
    ) {
      setAllRequired(true);
    } else {
      setAllRequired(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    fields,
    bugsDateBack,
    priorityStats,
    vendorStatuses,
    vendorEventScopes,
    priorityMaps,
    subscriptions,
    vendorImpactedRegions,
    keywords,
    searchFields,
    snCompanySysId
  ]);

  return (
    <>
      <TabNav
        vendorId={vendorId}
        credentials={true}
        activeTab={activeTab}
        snIntegrationCheck={snIntegrationCheck}
        setActiveTab={setActiveTab}
        setIsLoading={setIsLoading}
        isLoading={isLoading}
        setServices={setServices}
        setVendors={setVendors}
        buildVendorStat={buildVendorStat}
        setPriorityStats={setPriorityStats}
        setBugs={setBugs}
        isConfigured={isConfigured}
        loading={loading}
      />
      <TabContent>
        <TabOne
          vendorId={vendorId}
          vendorLabel={vendorLabel}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          snIntegrationCheck={snIntegrationCheck}
          services={services}
          vendors={vendors}
          priorityStats={priorityStats}
          isConfigured={isConfigured}
          modalOpen={modalOpen}
          setModalOpen={setModalOpen}
          setIsForceRun={setIsForceRun}
          timeUnit={timeUnit}
          setTimeUnit={setTimeUnit}
          timeValue={timeValue}
          setTimeValue={setTimeValue}
          schedulingMode={schedulingMode}
          setSchedulingMode={setSchedulingMode}
          schedules={schedules}
          setSchedules={setSchedules}
          nextRun={nextRun}
          setNextRun={setNextRun}
          loading={loading}
          isServiceActive={isServiceActive}
          setIsServiceActive={setIsServiceActive}
        />
        <form noValidate style={{ minWidth: '100%' }}>
          <input type="hidden" value="prayer" />
          <TabPane tabId="2">
            {activeTab === '2' && (
              <Card bg={'light'} text={'dak'} className="mb-4">
                <CardBody>
                  <Row form>
                    <Col lg="12">
                      <FormGroup>
                        <Label>
                          Azure Admin Credentials
                          <span style={{ color: '#bd472a' }}>*</span>
                        </Label>
                        {!isAddingCredentials ? (
                          <>
                            <div>
                              <ButtonIcon
                                onClick={() => setIsAddingCredentials(true)}
                                color="falcon-default"
                                size="sm"
                                icon="plus"
                                iconClassName="fs--2"
                              >
                                Set Credentials
                              </ButtonIcon>

                              {fields.secretId || isValidCredentials ? (
                                <>
                                  {'  '}
                                  <FontAwesomeIcon icon={'check'} style={{ color: 'green', marginLeft: '10px' }} />{' '}
                                  Azure Credentials Stored
                                  <Row form>
                                    <Col lg="6" className="mt-3">
                                      <VendorMultiSelect
                                        options={subscriptionOptions}
                                        setHook={setSubscriptions}
                                        categories={subscriptions}
                                        handleSelectChange={handleSelectChange}
                                        isSubmitted={isSubmitted}
                                        feedback={'a subscription'}
                                        name={'Azure Subscriptions'}
                                        required={true}
                                      />
                                    </Col>
                                  </Row>
                                </>
                              ) : null}
                            </div>
                          </>
                        ) : (
                          <>
                            <Row>
                              <Col lg="4">
                                <FieldGroup
                                  type="text"
                                  id="tenantId"
                                  autoComplete="new-appId"
                                  onChange={handleFieldChange}
                                  value={fields.tenantId}
                                  label={'Azure Tenant ID'}
                                  showFeedback={!fields.tenantId && isSubmitted}
                                  feedback={'Please specify Azure Tenant ID.'}
                                  placeholder="Enter Azure Tenant ID"
                                  style={{ marginBottom: '10px' }}
                                  required
                                />
                              </Col>
                              <Col lg="4">
                                <FieldGroup
                                  type="text"
                                  id="appId"
                                  label={'App ID'}
                                  autoComplete="new-appId"
                                  placeholder="Enter App ID"
                                  onChange={handleFieldChange}
                                  value={fields.appId}
                                  showFeedback={!fields.appId && isSubmitted}
                                  feedback={'Please specify an App ID.'}
                                  required
                                />
                              </Col>
                              <Col lg="4">
                                <FieldGroup
                                  type="password"
                                  id="clientSecret"
                                  label={'Client Secret'}
                                  autoComplete="new-appId"
                                  placeholder="Enter Client Secret"
                                  onChange={handleFieldChange}
                                  value={fields.clientSecret}
                                  showFeedback={!fields.clientSecret && isSubmitted}
                                  feedback={'Please specify a Client Secret.'}
                                  required
                                />
                              </Col>
                            </Row>

                            <CredsModal
                              isTestingValidCredentials={isTestingValidCredentials}
                              setIsTestingCredentials={setIsTestingValidCredentials}
                              fields={fields}
                              testCreds={testCreds}
                              vendorId={vendorId}
                            />
                            <ButtonIcon
                              onClick={() => setIsAddingCredentials(false)}
                              color="falcon-default"
                              size="sm"
                              icon="times"
                              iconclassname="fs--2"
                              style={{ marginRight: '10px' }}
                            >
                              Cancel
                            </ButtonIcon>
                          </>
                        )}
                        <Col xs={'5'}>
                          <Row>
                            <FormFeedback
                              className={
                                !fields.secretId && !fields.tenantId && !fields.appId && isSubmitted ? 'd-block' : ''
                              }
                              type="invalid"
                            >
                              <Alert color="danger">Please specify credentials.</Alert>
                            </FormFeedback>
                          </Row>
                        </Col>
                      </FormGroup>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            )}
          </TabPane>
          <DefaultConfigTab
            vendor={vendor}
            vendorId={vendorId}
            activeTab={activeTab}
            vendorLabel={vendorLabel}
            bugsDateBack={bugsDateBack}
            setBugsDateBack={setBugsDateBack}
            isSubmitted={isSubmitted}
            snCompanySysIdErrors={snCompanySysIdErrors}
            snCompanySysIdOptions={snCompanySysIdOptions}
            setSnCompanySysId={setSnCompanySysId}
            snCompanySysId={snCompanySysId}
            fields={fields}
            handleFieldChange={handleFieldChange}
            autoClose={autoClose}
            setAutoClose={setAutoClose}
          />

          <TabPane tabId="4">
            {activeTab === '4' && (
              <>
                <AWSFilters
                  vendorEventScopeOptions={vendorEventScopeOptions}
                  handleFieldChange={handleFieldChange}
                  setVendorEventScopes={setVendorEventScopes}
                  isSubmitted={isSubmitted}
                  vendorEventScopes={vendorEventScopes}
                />
                <ProductPriority
                  title="Default Bug Configuration"
                  vendorPriorityOptions={vendorPriorityOptions}
                  vendorStatusOptions={vendorStatusOptions}
                  vendorBugCategoryOptions={vendorBugCategoryOptions}
                  vendorBugTypeOptions={vendorBugTypeOptions}
                  setVendorBugCategories={setVendorBugCategories}
                  vendorBugCategories={vendorBugCategories}
                  setVendorBugTypes={setVendorBugTypes}
                  vendorBugTypes={vendorBugTypes}
                  setVendorStatuses={setVendorStatuses}
                  vendorStatuses={vendorStatuses}
                  isSubmitted={isSubmitted}
                  priorityMaps={priorityMaps}
                  setPriorityMaps={setPriorityMaps}
                  snPriorityOptions={snPriorityOptions}
                  keywords={keywords}
                  setKeywords={setKeywords}
                  searchFields={searchFields}
                  setSearchFields={setSearchFields}
                  // vendorEventLevelOptions={vendorEventLevelOptions}
                  // vendorEventLevels={vendorEventLevels}
                  // setVendorEventLevels={setVendorEventLevels}
                  vendorImpactedRegions={vendorImpactedRegions}
                  setVendorImpactedRegions={setVendorImpactedRegions}
                  vendorImpactedRegionOptions={vendorImpactedRegionOptions}
                />
              </>
            )}
          </TabPane>
          <TabPane tabId="6">{activeTab === '6' && <ExecutionStatsTab vendorId={vendorId} />}</TabPane>
          <Row className={`${activeTab === '1' ? 'd-none' : ''} flex-between-center`}>
            <Col xs="auto">
              <Button
                block
                color="falcon-danger"
                onClick={() => {
                  console.log(`/vendors/${vendorId}/configuration`);
                  navigate(-1);
                }}
              >
                Cancel
              </Button>
            </Col>
            <Col xs="auto">
              <SummaryModal
                modalOpen={modalOpen}
                isReadOnly={isReadOnly}
                setModalOpen={setModalOpen}
                handleSave={handleSave}
                isLoading={isLoading}
                vendorLabel={vendorLabel?.replace('Systems', 'Networks')}
                vendorId={vendorId}
                validated={validated}
                setValidated={setValidated}
                syncOnly={syncOnly}
                setSyncOnly={setSyncOnly}
                handleValidationError={handleValidationError}
                allRequired={allRequired}
                isUpdated={isUpdated}
              />
            </Col>
          </Row>
        </form>
      </TabContent>
    </>
  );
};
// };
ConfigFormAzure.propTypes = {
  vendor: PropTypes.object,
  isReadOnly: PropTypes.bool,
  settings: PropTypes.object,
  vendorLabel: PropTypes.string,
  vendorId: PropTypes.string,
  vendorPriorityOptions: PropTypes.array,
  vendorStatusOptions: PropTypes.array,
  vendorResolutionOptions: PropTypes.array,
  snIntegrationCheck: PropTypes.bool,
  services: PropTypes.array,
  vendors: PropTypes.array,
  bugs: PropTypes.object,
  priorityStats: PropTypes.object,
  setPriorityStats: PropTypes.func,
  bugOptions: PropTypes.array,
  selectedBugOption: PropTypes.object,
  setSelectedBugOption: PropTypes.func,
  snCompanySysIdOptions: PropTypes.object,
  snCompanySysId: PropTypes.object,
  snCompanySysIdErrors: PropTypes.bool,
  vendorBugTypeOptions: PropTypes.array,
  vendorBugCategoryOptions: PropTypes.array,
  vendorEventScopes: PropTypes.array,
  setVendorEventScopes: PropTypes.func,
  vendorEventScopeOptions: PropTypes.array,
  vendorResolutions: PropTypes.array,
  setVendorResolutions: PropTypes.func,
  setVendorStatuses: PropTypes.func,
  vendorStatuses: PropTypes.array,
  fields: PropTypes.object,
  handleFieldChange: PropTypes.func,
  priorityMaps: PropTypes.array,
  setPriorityMaps: PropTypes.func,
  snPriorityOptions: PropTypes.array,
  keywords: PropTypes.array,
  setKeywords: PropTypes.func,
  searchFields: PropTypes.array,
  setSearchFields: PropTypes.func,
  setSnCompanySysId: PropTypes.func,
  subscriptions: PropTypes.array,
  setSubscriptions: PropTypes.func,
  subscriptionOptions: PropTypes.array,
  setSubscriptionOptions: PropTypes.func,
  vendorBugTypes: PropTypes.array,
  setVendorBugTypes: PropTypes.func,
  vendorBugCategories: PropTypes.array,
  setVendorBugCategories: PropTypes.func,
  bugsDateBack: PropTypes.string,
  setBugsDateBack: PropTypes.func,
  setServices: PropTypes.func,
  setVendors: PropTypes.func,
  buildVendorStat: PropTypes.func,
  setBugs: PropTypes.func,
  isConfigured: PropTypes.bool,
  // vendorEventLevelOptions: PropTypes.array,
  // vendorEventLevels: PropTypes.array,
  // setVendorEventLevels: PropTypes.func,
  syncOnly: PropTypes.bool,
  setSyncOnly: PropTypes.func,
  vendorImpactedRegions: PropTypes.array,
  setVendorImpactedRegions: PropTypes.func,
  vendorImpactedRegionOptions: PropTypes.array,
  loading: PropTypes.bool,
  autoClose: PropTypes.bool,
  setAutoClose: PropTypes.func,
  setIsServiceActive: PropTypes.func,
  isServiceActive: PropTypes.number,
  allRequired: PropTypes.bool,
  isUpdated: PropTypes.bool,
  setAllRequired: PropTypes.func,
  setIsUpdated: PropTypes.func
};
export default ConfigFormAzure;
